export default "__VITE_ASSET__D$hesC8D__"